import BreadCrumbs from '@/components/probaworkflows_base_components/Breadcrumbs/BreadCrumbs.vue';

export default {
  name: 'NavBackButton',
  components: {
    BreadCrumbs,
  },
}